<template>
  <div v-loading="loading">
    <ul class="aside_box appPrivacy">
      <li v-if="aside!=2" class="titleLi" @click="Aside('2')">{{ $t('title.userAgreement') }}</li>
      <li v-if="aside==2">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=1" class="titleLi" @click="Aside('1')">privacyNotice{{ $t('title.privacyNotice') }}</li>
      <li v-if="aside==1">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=3" class="titleLi" @click="Aside('3')">{{$t('title.chTradingRules')}}</li>
      <li v-if="aside==3">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=4" class="titleLi" @click="Aside('4')">{{$t('title.auctionRules')}}</li>
      <li v-if="aside==4">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <!-- <li :class="aside==5?'on':''" @click="Aside('5')">{{ $t('title.activityRule') }}</li> -->
      <!-- <li :class="aside==6?'on':''" @click="Aside('6')">{{ $t('title.settlementAgreement') }}</li> -->
      <li v-if="aside!=7" class="titleLi" @click="Aside('7')">{{$t('title.closingDeleting')}}</li>
      <li v-if="aside==7">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
      <li v-if="aside!=8" class="titleLi" @click="Aside('8')">{{ $t('title.boxesCases') }}</li>
      <li v-if="aside==8">
        <div id="container" class="article_appbox" v-html="list.Content">
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
export default {
  name: 'index',
  data() {
    return {
      loading: false,
      list: '',
      aside: 2,
      policies: this.$enumInfo.policies,
      title: this.$t('title.rulesAPolicies')
    }
  },
  mounted() {},
  created() {
    this.aside = this.$route.query.type ? this.$route.query.type : 2;
    document.title = this.policies[this.aside];
    this.GetAgreements()
  },
  methods: {
    Aside(val) {
      this.aside = val;
      this.GetAgreements();
      window.scrollTo(0, 0)
    },
    GetAgreements() {
      let that = this
      let data = { ServiceAgreementType: this.aside }
      that.loading = true;
      this.$get(this.$interface.GetNewServiceAgreements, data).then(res => {
        if (res.Result != 0) {
          if (res.Data.length > 0) {
            this.list = res.Data[0]
          } else {
            this.list.Content = ""
          }
        }
        that.loading = false;
      })
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/terms.css";

</style>



// WEBPACK FOOTER //
// src/pages/terms/appprivacy.vue